import {resources} from "../../../../core/models/resource/resources";

export const dailyFeedbackReportsResourceType = resources['daily-feedback-reports'];

export const baseBottomOffset: number = 270;
